import calendarIcon from './maintenance-assets/calendar.svg';
import chocolateShape from './maintenance-assets/chocolate.png';
import logo from './maintenance-assets/logo.svg';
import pinkHornShape from './maintenance-assets/pink-horn.png';
import './maintenancePage.css';

export function MaintenancePage() {
  return (
    <div className="maintenance-container">
      <div className="maintenance-logo-header">
        <img src={logo} alt="Pfida" className="maintenance-logo" />
      </div>

      <div className="maintenance-card">
        <div className="maintenance-calendar-icon">
          <img src={calendarIcon} alt="Calendar" />
        </div>

        <h1 className="maintenance-title">We&apos;re Currently Under Maintenance</h1>

        <p className="maintenance-description">
          We&apos;re making important improvements behind the scenes. The platform is temporarily unavailable. Please
          check back in a few hours for a smoother, more secure experience.
        </p>
      </div>

      <div className="maintenance-background-shapes">
        <div
          className="maintenance-shape maintenance-shape-yellow"
          style={{ backgroundImage: `url(${chocolateShape})` }}
        />
        <div className="maintenance-pink-hover-area">
          <div
            className="maintenance-shape maintenance-shape-pink"
            style={{ backgroundImage: `url(${pinkHornShape})` }}
          />
        </div>
      </div>
    </div>
  );
}
